import React, { ElementType } from 'react';
import { CardBaseHeader, IconName, Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { OperationCardDocumentContent, OperationsCardStyles } from './Styles';

type Props = {
  title?: string;
  children?: React.ReactNode;
  contentElementType?: ElementType;
  className?: string;
  iconName?: IconName;
  icon?: React.ReactNode;
  loading?: boolean;
  hasError?: boolean;
  empty?: boolean;
};

export const OperationsCardDocument = ({
  title,
  children,
  contentElementType,
  className,
  iconName,
  icon,
  loading,
  hasError,
  empty,
}: Props) => {
  const { t } = useTranslation();

  const getLoadingItem = () => (
    <>
      <div style={{ width: '100%' }}>
        <Skeleton height={18} width="40%" borderRadius={8} />
      </div>
      {iconName && <Skeleton height={18} width={18} borderRadius={8} />}
    </>
  );

  const getItem = () => (
    <>
      {title && (
        <Label fontSize="14" semibold ellipsis>
          {t(title)}
        </Label>
      )}
      {icon && <>{icon}</>}
    </>
  );

  return (
    <OperationsCardStyles
      flexDirection="column"
      className={className}
      $hasError={hasError}
    >
      {title && (
        <CardBaseHeader>
          {loading ? getLoadingItem() : getItem()}
        </CardBaseHeader>
      )}
      <OperationCardDocumentContent as={contentElementType} empty={empty}>
        {children}
      </OperationCardDocumentContent>
    </OperationsCardStyles>
  );
};
